import * as React from "react";
const SvgLock = (props) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 26, viewBox: "0 0 25 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.44922 9.93658V6.95772C6.44922 3.48456 8.98592 1 12.4591 1C15.9322 1 18.7478 3.43576 18.7478 6.90891V9.93658", stroke: "#2C855D", style: {
  stroke: "#2C855D",
  stroke: "color(display-p3 0.1725 0.5216 0.3647)",
  strokeOpacity: 1
}, strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M3 22.183V9.93652H22.1971V22.183L12.2676 24.4998L3 22.183Z", stroke: "#2C855D", style: {
  stroke: "#2C855D",
  stroke: "color(display-p3 0.1725 0.5216 0.3647)",
  strokeOpacity: 1
}, strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.4678 14.3486C15.6132 14.494 15.6132 14.7297 15.4678 14.8752L11.7442 18.5987C11.5988 18.7441 11.363 18.7441 11.2176 18.5987L9.7282 17.1093C9.58279 16.9639 9.58279 16.7281 9.7282 16.5827C9.87362 16.4373 10.1094 16.4373 10.2548 16.5827L11.4809 17.8088L14.9412 14.3486C15.0866 14.2031 15.3224 14.2031 15.4678 14.3486Z", fill: "#1A2A3A", stroke: "#2C855D", style: {
  fill: "#1A2A3A",
  fill: "color(display-p3 0.1020 0.1647 0.2275)",
  fillOpacity: 1,
  stroke: "#2C855D",
  stroke: "color(display-p3 0.1725 0.5216 0.3647)",
  strokeOpacity: 1
}, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgLock;
